import styled from '@emotion/styled';

export const StyledSearchResults = styled.div(({ theme }) => ({
    padding: theme.space[5],
}));
